
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.285 6.297a1 1 0 011.414 1.414L13.409 12l4.29 4.29a1 1 0 01.083 1.32l-.083.093a1 1 0 01-1.414 0l-4.29-4.29-4.28 4.282a1 1 0 01-1.32.083l-.094-.083a1 1 0 010-1.415l4.28-4.28-4.28-4.28a1 1 0 01-.083-1.32l.083-.095a1 1 0 011.414 0l4.28 4.28z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    